import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import routes from './routes';
import './scss/global.scss'
import { ConfigProvider } from 'antd';
import { Provider } from 'react-redux';
import store from './store';
import GlobalNotification from './utils/globalNotification/globalNotification';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#1677FF",
          colorPrimaryBorder: "#C9EEF2",
          colorSuccess: "#34C759",
          colorError: "#FF3B30"
        }
      }}
    >
      <Provider store={store}>
        <RouterProvider router={routes} />
        <GlobalNotification />
      </Provider>
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
